/* ============================================================================
   Byrna Q-end gift-with-purchase selector — behaviour. (#ISSUE)

   Loaded SITEWIDE from layout/theme.liquid with `defer`, deliberately NOT from
   snippets/byrna-gift-tier.liquid. The snippet renders inside .ajax-cart__list
   / .cart__item-list, both of which are replaceWith()n on every cart mutation;
   a <script> in there would be re-executed by jQuery each time. Same reason
   byrna-cart-restrictions.js is loaded sitewide.

   CONTRACT — Liquid decides, this file only acts. No subtotal maths here. The
   snippet emits:
     data-bgw-state        below | choose | chosen | evict
     data-bgw-threshold    cents
     data-bgw-evict        comma-separated cart line keys to remove
     data-bgw-current-key  cart line key of the currently chosen gift
     data-bgw-add          (on each button) variant id to add

   HAZARDS THIS GUARDS AGAINST, all observed in z__jsAjaxCart.js:
   - updateView()'s .fail() is an empty stub, so a failed fetch leaves the DOM
     stale with no signal. Evict is therefore idempotent and re-checked on the
     next mutation rather than assumed to have worked.
   - The item_count === 0 branch of updateView() does NO replaceWith, only
     toggles is-hidden, so stale markup persists. We re-read the DOM each pass
     instead of caching a root node.
   - unload() calls .off() with element selectors on handlers that are
     document-delegated, so repeated init() in the theme editor stacks
     duplicates. Hence the module-level init guard below.
   - Evicting mutates the cart, which fires the observer, which re-runs the
     check. Hence the busy flag.

   The pre-evict /cart.js confirmation is only sound while the gift variants
   are priced $0 — that is what makes cart.original_total_price equal to the
   snippet's gift-excluded subtotal. If the gift is ever priced above zero,
   delete the confirmation rather than "fixing" it; the server is the source
   of truth.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__byrnaGiftTierInit) { return; }
  window.__byrnaGiftTierInit = true;

  var busy = false;

  function root() {
    return document.querySelector('[data-bgw]');
  }

  function setBusy(state) {
    busy = state;
    var els = document.querySelectorAll('[data-bgw]');
    for (var i = 0; i < els.length; i++) {
      if (state) { els[i].setAttribute('data-bgw-busy', '1'); }
      else { els[i].removeAttribute('data-bgw-busy'); }
    }
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body),
      credentials: 'same-origin'
    }).then(function (r) {
      if (!r.ok) { throw new Error(url + ' -> ' + r.status); }
      return r.json();
    });
  }

  function refresh() {
    // The cart page's .cart__item-list is refreshed by z__jsCart, but it
    // exposes no documented entry point, so reload there. The drawer has
    // Shopify.theme.jsAjaxCart.updateView() (globally reachable; see recon).
    if (document.querySelector('.cart__item-list')) {
      window.location.reload();
      return;
    }
    if (window.Shopify && Shopify.theme && Shopify.theme.jsAjaxCart &&
        typeof Shopify.theme.jsAjaxCart.updateView === 'function') {
      Shopify.theme.jsAjaxCart.updateView();
    } else {
      window.location.reload();
    }
  }

  function removeKeys(keys) {
    return keys.reduce(function (chain, key) {
      return chain.then(function () {
        return post('/cart/change.js', { id: key, quantity: 0 });
      });
    }, Promise.resolve());
  }

  function runEvict() {
    var el = root();
    if (!el || busy) { return; }
    var list = el.getAttribute('data-bgw-evict');
    if (!list) { return; }
    var threshold = parseInt(el.getAttribute('data-bgw-threshold'), 10);
    var keys = list.split(',').filter(Boolean);
    if (!keys.length) { return; }

    setBusy(true);
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Confirm the server's verdict before mutating. Guards against acting
        // on a stale render left behind by updateView()'s silent failure path.
        var qty = 0;
        for (var i = 0; i < cart.items.length; i++) {
          if (keys.indexOf(cart.items[i].key) !== -1) { qty += cart.items[i].quantity; }
        }
        var overThreshold = cart.original_total_price >= threshold;
        if (overThreshold && qty <= 1) { return null; }
        return removeKeys(keys);
      })
      .then(function (didRemove) {
        setBusy(false);
        if (didRemove !== null) { refresh(); }
      })
      .catch(function () {
        // Leave the gift in place and let the next mutation re-check.
        setBusy(false);
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-bgw-add]') : null;
    if (!btn) { return; }
    e.preventDefault();
    if (busy) { return; }

    var el = root();
    if (!el) { return; }
    var variantId = parseInt(btn.getAttribute('data-bgw-add'), 10);
    if (!variantId) { return; }

    var currentKey = el.getAttribute('data-bgw-current-key');
    var alreadyThis = btn.classList.contains('is-selected');
    if (alreadyThis) { return; }

    setBusy(true);
    var chain = Promise.resolve();
    if (currentKey) {
      // Swap: remove the existing gift first so we never transiently hold two,
      // which the snippet would treat as an abuse case and evict both.
      chain = chain.then(function () { return removeKeys([currentKey]); });
    }
    chain
      .then(function () { return post('/cart/add.js', { id: variantId, quantity: 1 }); })
      .then(function () { setBusy(false); refresh(); })
      .catch(function () { setBusy(false); refresh(); });
  });

  function watch() {
    var targets = document.querySelectorAll('.theme-ajax-cart, .cart__item-list');
    for (var i = 0; i < targets.length; i++) {
      new MutationObserver(function () { runEvict(); })
        .observe(targets[i], { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { runEvict(); watch(); });
  } else {
    runEvict();
    watch();
  }
})();
